import lodashFind from "lodash/find";
import lodashHas from "lodash/has";
import lodashCloneDeep from "lodash/cloneDeep";
import dayjs from "dayjs";

import { GET_NOTIFICATION_RESET } from "./actions.type";
import {
  SET_NOTIFICATION_STEP,
  SET_NOTIFICATION_RESET,
} from "./mutations.type";

const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const VALIDATORS = {
  frequency: () => {
    let valid = false;
    const step = lodashFind(STATE.steps, ["name", "frequency"]);
    if (step) {
      if (step.value) {
        if (
          step.value.delivery &&
          Array.isArray(step.value.delivery) &&
          step.value.delivery.length
        ) {
          if (step.value.frequency) {
            if (
              step.value.frequency.toLowerCase() === "immediately" ||
              step.value.frequency.toLowerCase() === "hourly" ||
              (step.value.frequency.toLowerCase() === "weekly" &&
                step.value.dayOfWeek &&
                step.value.timeOfDay) ||
              (step.value.frequency.toLowerCase() === "daily" &&
                step.value.timeOfDay)
            ) {
              if (
                step.value.expiration === "never" ||
                step.value.expirationDate
              ) {
                valid = true;
              } else {
                console.warn(
                  "notifications.module.js",
                  "Expiration issue",
                  step.value.expiration,
                  step.value.expirationDate
                );
              }
            } else {
              console.warn(
                "notifications.module.js",
                "Frequency/schedule issue",
                step.value
              );
            }
          } else {
            console.warn(
              "notifications.module.js",
              "Frequency not set",
              step.value
            );
          }
        } else {
          console.warn(
            "notifications.module.js",
            "Delivery not set",
            step.value
          );
        }
      } else {
        console.warn(
          "notifications.module.js",
          "Step.value not found for Frequency",
          step
        );
      }
    } else {
      console.warn(
        "notifications.module.js",
        "Step not found for Frequency",
        STATE.steps
      );
    }
    return valid;
  },
  sharing: () => {
    let valid = false;
    const step = lodashFind(STATE.steps, ["name", "sharing"]);
    if (step) {
      if (step.value) {
        if (step.value.shareWithColleagues === "no") {
          valid = true;
        } else {
          if (
            step.value.sharedList &&
            Array.isArray(step.value.sharedList) &&
            step.value.sharedList.length
          ) {
            valid = true;
          } else {
            console.warn(
              "notifications.module.js",
              "shareWithColleagues is yes but no colleagues selected",
              step
            );
          }
        }
      } else {
        console.warn(
          "notifications.module.js",
          "Step.value not found for Sharing",
          step
        );
      }
    } else {
      console.warn(
        "notifications.module.js",
        "Step not found for Sharing",
        STATE.steps
      );
    }
    return valid;
  },
};

const STEP_VALUE_DEFAULTS = {
  frequency: {
    frequency: "IMMEDIATELY", // immediately, hourly, weekly, or daily
    dayOfWeek: daysOfWeek[dayjs().day()], // if weekly: monday, tuesday, wednesday, thursday, friday, saturday, sunday
    timeOfDay: `${dayjs().format("HH:mm")}`, // if weekly or daily: has to be on the hour or half hour only, use 24hr clock
    expiration: 1, // null=none, 1 week, 2 weeks, 3 weeks (set the date in the future)
    expirationDate: null,
    delivery: ["email"], // email, push
  },
  sharing: {
    shareWithColleagues: "no", // yes or no
    sharedList: null, // array of objects containing userid and email
  },
};

const STATE = {
  steps: [
    {
      name: "frequency",
      step: 1,
      title: "Frequency & Delivery",
      component: "NotificationsStepFrequency",
      rules: [VALIDATORS["frequency"]],
      optional: false,
      complete: false,
      value: STEP_VALUE_DEFAULTS["frequency"],
    },
    {
      name: "sharing",
      step: 2,
      title: "Sharing",
      component: "NotificationsStepShare",
      rules: [VALIDATORS["sharing"]],
      optional: true,
      complete: false,
      value: STEP_VALUE_DEFAULTS["sharing"],
    },
  ],
  validators: VALIDATORS,
};

const GETTERS = {
  steps: (state) => state.steps,
  validators: (state) => state.validators,
};

const ACTIONS = {
  [GET_NOTIFICATION_RESET](context, params) {
    const steps = lodashCloneDeep(context.state.steps);
    steps.forEach((step) => {
      step.complete = false;
      step.value = STEP_VALUE_DEFAULTS[step.name];
    });
    context.commit(SET_NOTIFICATION_RESET, steps);
  },
};

const MUTATIONS = {
  [SET_NOTIFICATION_STEP](state, data) {
    if (data && data.name) {
      const step = lodashFind(state.steps, ["name", data.name]);
      if (step) {
        if (lodashHas(data, "value")) {
          step.value = data.value;
        }
        const valid = state.validators[data.name]();
        step.complete = valid;
      }
    }
  },
  [SET_NOTIFICATION_RESET](state, data) {
    state.steps = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
